"use client";

import { JobModal } from "../components/JobModal";
import { JobTable } from "../components/JobTable";
import {
  JobsManagementProvider,
  useJobsManagement
} from "@/components/common/JobsManagementBase";

function SettingsJobsContent() {
  const {
    jobs,
    isJobModalOpen,
    selectedJob,
    setIsJobModalOpen,
    jobProfiles,
    companyId,
    fetchJobs,
    facilities
  } = useJobsManagement();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Stellenangebote</h2>
        <p className="text-muted-foreground">
          Verwalte die Stellenangebote deines Unternehmens.
        </p>
      </div>

      <JobTable jobs={jobs} />

      <JobModal
        open={isJobModalOpen}
        onOpenChange={setIsJobModalOpen}
        currentJob={selectedJob}
        title={selectedJob ? "Stelle bearbeiten" : "Neue Stelle hinzufügen"}
        jobProfiles={jobProfiles}
        companyId={companyId}
        onJobSaved={() => companyId && fetchJobs(companyId)}
        facilities={facilities}
      />
    </div>
  );
}

export default function SettingsJobs() {
  return (
    <JobsManagementProvider>
      <SettingsJobsContent />
    </JobsManagementProvider>
  );
}
